import type { AccentHue } from "@repo/fika-design-system/color"
import type { ParentProps } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { boxRecipe } from "./well.css"

type Props = {
  hue?: AccentHue
} & ParentProps
export function Well(props: Props) {
  return <Box class={boxRecipe({ hue: props.hue })}>{props.children}</Box>
}
